import ToppingsStepDesktop from './ToppingsStepDesktop';

export default ToppingsStepDesktop;
